module.exports = __webpack_public_path__ + "it.svg?38e71ef690245d3e1b365d2f806f822f";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/it.svg
// module id = 1036
// module chunks = 27